// Shows are stored as plain YYYY-MM-DD, so parse them as local dates — never
// through `new Date(iso)`, which treats them as UTC and shifts the day back.
export function parseShowDate(iso) {
  const [y, m, d] = String(iso || "").split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function formatShowDate(iso, opts = {}) {
  const dt = parseShowDate(iso);
  if (!dt) return iso || "";
  return dt.toLocaleDateString("en-US", {
    weekday: opts.weekday === false ? undefined : "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function showDateParts(iso) {
  const dt = parseShowDate(iso);
  if (!dt) return { month: "", day: "", year: "" };
  return {
    month: dt.toLocaleDateString("en-US", { month: "short" }).toUpperCase(),
    day: String(dt.getDate()),
    year: String(dt.getFullYear()),
  };
}
